const communityUserRoutes = [
  {
    path: '',
    name: 'Posts',
    meta: {
      title: {
        en: 'Posts',
        ru: 'Посты',
      },
    },
    component: () => import(/* webpackChunkName: "profile-blogposts" */ '@martyrs/src/modules/auth/views/components/pages/ProfileBlogposts.vue'),
  },
];

export default communityUserRoutes;
